import { render, staticRenderFns } from "./Showactmyorder.vue?vue&type=template&id=2525e09c&"
import script from "./Showactmyorder.vue?vue&type=script&lang=js&"
export * from "./Showactmyorder.vue?vue&type=script&lang=js&"
import style0 from "./Showactmyorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports